import { useAppSelector } from '@store/index';
import { User } from '../store/slices/user.slice';

/**
 * Custom hook to manage user data.
 *
 * This hook retrieves user data from local storage and provides it to the component.
 * It uses the useLocalStorage hook to access the storage functionality.
 *
 * @returns {User} The user data retrieved from local storage.
 */
const useUser = (): User => {
  const data = useAppSelector((state) => state.user);

  return data?.info;
};

export default useUser;
